import React from 'react';

export default ({ to, onClick, className }) => (
  <button
    type="button"
    onClick={onClick}
    className={`button button--text button--icon ${className}`}
    aria-label={to}
  >
    {to === 'prev' ?
      <img
        src="/img/slickarrowleft.svg"
        alt="slickarrowleft"
        height="19px"
      /> :
      <img
        src="/img/slickarrowright.svg"
        alt="slickarrowright"
        height="19px"
      />}
  </button>
);



// WEBPACK FOOTER //
// ./src/components/modules/sliderArrow/SliderArrow.js